import PropTypes from 'prop-types'

import { ElectricVehicleProfileScopeTypes } from '../../models/electric/electric-vehicle-profile-scope-enum.js'
import { idPropType } from '../common/id-prop-type.js'
import { batteryCurveEntryPropType } from './battery-curve-entry-prop-type.js'

/**
 * @typedef {Object} ElectricVehicleBatteryCurveProfile
 *
 * @property {Array<BatteryCurveEntry>} - The electric vehicle battery charging characteristics array
 * @property {string} dataScope - The scope of the energy consumptions entries. Values may be calculated basing on single object when enough data and for whole generation
 * @property {number} estimatedBatteryCapacity - Estimated battery capacity - the value decreases over time - measured in kWh unit
 * @property {number} maxACPowerInkW - Maximum charging power in case of AC charger usage measured in kW unit
 * @property {number} maxDCPowerInkW - Maximum charging power in case of DC charger usage measured in kW unit
 * @property {string} objectId - The object id unique identifier
 */
export const electricVehicleBatteryCurveProfilePropType = PropTypes.shape({
    batteryCurve: PropTypes.arrayOf(batteryCurveEntryPropType),
    dataScope: PropTypes.oneOf(Object.values(ElectricVehicleProfileScopeTypes)).isRequired,
    estimatedBatteryCapacity: PropTypes.number,
    maxACPowerInkW: PropTypes.number,
    maxDCPowerInkW: PropTypes.number,
    objectId: idPropType.isRequired
})
